import Image from "next/image";
import React from "react";
import { ButtonProps } from "@/types/ui-kit/buttons";

export const OpenContentButton: React.FC<ButtonProps> = ({ title, onClick, styles }) => {
  return (
    <>
      <button
        className="relative mt-0 flex w-full cursor-pointer items-center justify-center rounded-sm border border-dark-10 px-5 py-2 transition-colors ease-in-out hover:border-dark hover:bg-gray-100 dark:border-white-25 dark:text-white dark:hover:bg-white-25"
        onClick={onClick}
      >
        <Image
          src={"/assets/images/icons/chevron-down-dark.svg"}
          alt="Chevron Down"
          width={10}
          height={10}
          className={`${styles} dark:invert`}
        />
        <span className="justify-self-center">{title ?? ""}</span>
      </button>
    </>
  );
};
